(function ($) {
  DJ.addBehavior('btnJoinUs', '.join-us', {
    attach: function () {
      const $button = $('.join-us__button', $(this));
      const $modalContent = $('.join-us__content', $(this));

      $button.on('click', (e) => {
        const bool = $modalContent.is(':hidden');
        $(e.target).toggleClass('is-active');
        $modalContent.attr('hidden', !bool);
      });

      $('body').on('click', (e) => {
        if ($(e.target).closest('.join-us').length !== 1) {
          $button.removeClass('is-active');
          $modalContent.attr('hidden', true);
        }
      });

      $(window).scroll(() => {
        $button.removeClass('is-active');
        $modalContent.attr('hidden', true);
      });
    }
  });
})(jQuery);
